/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blood-inventory-request-map.reducer';

export const BloodInventoryRequestMapDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bloodInventoryRequestMapEntity = useAppSelector(state => state.bloodInventoryRequestMap.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bloodInventoryRequestMapDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.detail.title">BloodInventoryRequestMap</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.id">Id</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryRequestMapEntity.id}</dd>
          <dt>
            <span id="servedBagNumber">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.servedBagNumber">Served Bag Number</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryRequestMapEntity.servedBagNumber}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.active">Active</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryRequestMapEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryRequestMapEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryRequestMapEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryRequestMapEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bloodInventoryRequestMapEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.fromInventory">From Inventory</Translate>
          </dt>
          <dd>{bloodInventoryRequestMapEntity.fromInventory ? bloodInventoryRequestMapEntity.fromInventory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.forRequest">For Request</Translate>
          </dt>
          <dd>{bloodInventoryRequestMapEntity.forRequest ? bloodInventoryRequestMapEntity.forRequest.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.bank">Bank</Translate>
          </dt>
          <dd>{bloodInventoryRequestMapEntity.bank ? bloodInventoryRequestMapEntity.bank.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/blood-inventory-request-map" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blood-inventory-request-map/${bloodInventoryRequestMapEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BloodInventoryRequestMapDetail;
